var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"visaButtonContainer"},[_c('img',{staticClass:"v-button",attrs:{"locale":"pl_PL","role":"button","src":_vm.buttonSrc,"alt":"Visa Checkout"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }